import type { IdWithName } from "@repo/shared/common";
import type { User } from "@repo/server-api";

export type { User };

// Model for creating a new login
export type CreateLoginModel = {
	contact: IdWithName | null;
	login: string;
	groups: string[];
	sendMail: boolean;
};

export const emptyCreateLoginModel: CreateLoginModel = {
	contact: null,
	login: "",
	groups: [],
	sendMail: false,
};

export type PaginationModel = {
	page: number;
	pageSize: number;
};

export type UseLoginsListReturn = {
	// Data
	rows: User[];
	rowCount: number;
	isLoading: boolean;

	// Search
	searchValue: string;
	setSearchValue: (value: string) => void;

	// Pagination
	paginationModel: PaginationModel;
	setPaginationModel: (model: PaginationModel) => void;

	// Actions
	deleteUser: (userId: string) => Promise<void>;
	refresh: () => void;
};

// Supplier member type for supplier impersonation
export type SupplierMember = {
	id: string;
	displayName: string;
};

// Empty user for creating new logins
export const emptyUser: User = {
	id: "",
	contactId: null,
	email: "",
	emailVerified: false,
	enabled: false,
	groups: [],
	username: "",
	firstName: "",
	lastName: "",
};
